var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{directives:[{name:"lxmv",rawName:"v-lxmv",value:({ bid: _vm.mvbid, lab: _vm.lab }),expression:"{ bid: mvbid, lab }"}],attrs:{"type":"button","disabled":_vm.disabled},on:{"click":_vm.handleClick}},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }